module.exports = __webpack_public_path__ + "static/img/top-img.b10a1fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/detailpic/U1668H/top-img.jpg
// module id = rXOJ
// module chunks = 51